// apiClient.js
import axios from 'axios';
import { createSignedJWT, generateUUIDv4 } from './jwt';

// Fetch DateTime; returns the raw string value from API.
export async function fetchDateTime({ proxyBase = '' } = {}) {
  try {
    const url = proxyBase
      ? `${proxyBase}/display/datetime`
      : 'https://api.markasignage.platfront.com/display/datetime';

    const res = await axios.get(url, {
      timeout: 10000,
      headers: { 'time-zone-offset': '+03:00' }
    });

    if (res && res.data && res.data.data) {
      return res.data.data;
    }
    throw new Error('API response was received but is malformed.');
  } catch (err) {
    if (err && err.response) {
      throw new Error('Server responded: ' + err.response.status + ' (' + (err.response.statusText || '') + ')');
    } else if (err && (err.code === 'ECONNABORTED' || (err.message && err.message.indexOf('timeout') !== -1))) {
      throw new Error('The request timed out. The server is not responding.');
    } else {
      throw new Error('Network blocked (CORS/TLS/origin on webOS); try a same-origin proxy.');
    }
  }
}

// Perform login; returns { data, status, uniqueId, xTraceId }.
export async function login({
  proxyBase = '',
  uniqueId,
  secret = 'fMfv4AEcXEh12JCmdnozGIxpKr6t0BoN',
  appVersion = '1.0.0',
  version = '1',
  lang = 'en',
  os = 'WEB',
  xTraceId
} = {}) {
  try {
    const usedUniqueId = uniqueId || generateUUIDv4();
    const jti = generateUUIDv4();
    const usedXTraceId = xTraceId || generateUUIDv4();
    const now = Math.floor(Date.now() / 1000);
    const exp = now + (365 * 24 * 60 * 60);

    const payload = { jti, sub: usedUniqueId, uniqueId: usedUniqueId, iat: now, exp };
    const jwtToken = await createSignedJWT(payload, secret);

    const url = proxyBase
      ? `${proxyBase}/display/auth/login`
      : 'https://api.markasignage.platfront.com/display/auth/login';

    const res = await axios.post(url, {}, {
      timeout: 15000,
      headers: {
        'Authorization': 'Bearer ' + jwtToken,
        'unique-id': usedUniqueId,
        'version': version,
        'accept-language': lang,
        'os': os,
        'app-version': appVersion,
        'x-trace-id': usedXTraceId
      }
    });

    return { data: res.data, status: res.status, uniqueId: usedUniqueId, xTraceId: usedXTraceId };
  } catch (err) {
    if (err && err.response) {
      throw new Error('Login server responded with status: ' + err.response.status);
    } else if (err && (err.code === 'ECONNABORTED' || (err.message && err.message.indexOf('timeout') !== -1))) {
      throw new Error('The login request timed out.');
    } else {
      throw new Error('Network blocked during login (CORS/TLS/origin); try proxy.');
    }
  }
}
